import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../scripts/control';
import '../../css/BdStyles.css';

const AdminRequests = () => {
  const [tags, setTags] = useState([]);
  const [requests, setRequests] = useState([]);

  // Cargar solicitudes pendientes
  fetch(`${API_BASE_URL}/api/user_requests.php?status=pending`)
  .then((res) => {
    const contentType = res.headers.get('Content-Type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return res.json();
    } else {
      return res.text().then((text) => {
        throw new Error(`Expected JSON, got: ${text}`);
      });
    }
  })
  .then((data) => setRequests(data.requests || []))
  .catch((err) => {
    setRequests([]); // Resetear a array vacío
  });
  useEffect(() => {
  // Cargar etiquetas
    fetch(`${API_BASE_URL}/api/get_tags.php`)
        .then((res) => res.json())
        .then((data) => setTags(data.tags || []))
        .catch(() => {});
}, []);


  const getTagName = (tagId) => {
    const tag = tags.find((t) => t.idTag === tagId);
    return tag ? tag.tagName : `Etiqueta ${tagId}`;
  };

  const handleAccept = async (request) => {
    const payload = { id: request.id, action: 'accept' };
    try {
      const response = await fetch(`${API_BASE_URL}/api/handle_request.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        alert('Solicitud aceptada');
        setRequests((prev) => prev.filter((r) => r.id !== request.id));
      } else {
        const errData = await response.json();
        alert('Error: ' + errData.message);
      }
    } catch (error) {
      alert("Error al procesar la solicitud.");
    }
  };

  const handleReject = async (request) => {
    const payload = { id: request.id, action: 'reject' };
    try {
      const response = await fetch(`${API_BASE_URL}/api/handle_request.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        alert('Solicitud rechazada');
        setRequests((prev) => prev.filter((r) => r.id !== request.id));
      } else {
        const errData = await response.json();
        alert('Error: ' + errData.message);
      }
    } catch (error) {
      alert("Error al procesar la solicitud.");
    }
  };

  // Función para renderizar los detalles de la solicitud
  const renderRequestDetails = (rawDataString, friendlyDataString) => {
    let dataObj = {};
    let friendlyData = {};
    try {
      dataObj = JSON.parse(rawDataString);
    } catch (e) {
      return <pre>{rawDataString}</pre>;
    }
    try {
      friendlyData = JSON.parse(friendlyDataString);
    } catch (e) {
      friendlyData = dataObj;
    }

    const fields = [
      { label: 'Nombre', key: 'movieName' },
      { label: 'Año', key: 'movieYear' },
      { label: 'Clasificación', key: 'movieAge' },
      { label: 'Duración', key: 'movieDuration' },
      { label: 'Texto alternativo', key: 'img_alt' },
    ];

    // Si se trata de una solicitud de edición con datos originales y nuevos
    if (friendlyData.originalData && friendlyData.newData) {
      return (
        <div>
          {fields.map((field) => {
            const original = friendlyData.originalData[field.key];
            const proposed = friendlyData.newData[field.key];
            if (original !== proposed) {
              return (
                <p key={field.key}>
                  <strong>{field.label}:</strong> {original} → {proposed}
                </p>
              );
            }
            return null;
          })}
          {friendlyData.tags && (
            <p>
              <strong>Etiquetas:</strong>{" "}
              {Array.isArray(friendlyData.tags)
                ? friendlyData.tags.map((tagId) => getTagName(tagId)).join(", ")
                : friendlyData.tags}
            </p>
          )}
          {friendlyData.tagDetails && (
            <p>
              <strong>Detalles etiquetas:</strong>{" "}
              {Object.entries(friendlyData.tagDetails).map(([tagId, detail]) => (
                <span key={tagId}>
                  {getTagName(Number(tagId))}: {detail || "(sin detalle)"};{" "}
                </span>
              ))}
            </p>
          )}
        </div>
      );
    } else {
      // Para solicitudes de creación
      return (
        <div>
          {fields.map((field) => (
            <p key={field.key}>
              <strong>{field.label}:</strong> {friendlyData[field.key]}
            </p>
          ))}
          {friendlyData.tags && (
            <p>
              <strong>Etiquetas:</strong>{' '}
              {Array.isArray(friendlyData.tags)
                ? friendlyData.tags.join(', ')
                : friendlyData.tags}
            </p>
          )}
          {friendlyData.tagDetails && (
            <p>
              <strong>Detalles etiquetas:</strong>{' '}
              {Object.entries(friendlyData.tagDetails).map(([tagName, detail]) => (
                <span key={tagName}>
                  {tagName}: {detail ? detail : ''};{' '}
                </span>
              ))}
            </p>
          )}
        </div>
      );
    }
  };

  return (
    <div className="bd">
    <div>
      <h2>Solicitudes pendientes</h2>
      {requests.length === 0 ? (
        <p>No hay solicitudes pendientes.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {requests.map((request) => {
            const rawData = request.request_data;
            const friendlyData = request.request_data_names;
            let movieName = '';
            try {
              const friendlyObj = JSON.parse(friendlyData);
              movieName = friendlyObj.newData?.movieName || friendlyObj.movieName || '';
            } catch (e) {
              try {
                const rawObj = JSON.parse(rawData);
                movieName = rawObj.newData?.movieName || rawObj.movieName || '';
              } catch (ex) {
                movieName = '';
              }
            }
            return (
              <li
                key={request.id}
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  marginBottom: '10px',
                  padding: '10px',
                }}
              >
                <h4>Solicitud ID: {request.id} <strong>Usuario:</strong> {request.username || "Desconocido"}</h4>
                <p>
                  <strong>Sección:</strong>{' '}
                  {request.contentType === "película" ? "Película" : request.contentType}
                </p>
                {renderRequestDetails(rawData, friendlyData)}
                <button
                  onClick={() => handleAccept(request)}
                  style={{ marginRight: '10px' }}
                >
                  Aceptar
                </button>
                <button onClick={() => handleReject(request)}>Rechazar</button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
    </div>
  );
};

export default AdminRequests;